import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconImage from "@arco-design/web-react/icon/react-icon/IconImage";
import "@arco-design/web-react/es/Image/style";
import _Image from "@arco-design/web-react/es/Image";
import _IconImageClose from "@arco-design/web-react/icon/react-icon/IconImageClose";
import React, { useState } from 'react';
export function DisplayImage({
  src,
  show = false
}) {
  const [visible, setVisible] = useState(false);

  if (!src || src === '-') {
    return /*#__PURE__*/React.createElement("div", null, "-");
  }

  if (show) {
    return /*#__PURE__*/React.createElement(_Image, {
      height: 36,
      width: 64,
      src: src,
      alt: "...",
      error: /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col items-center justify-center w-full h-full"
      }, /*#__PURE__*/React.createElement(_IconImageClose, {
        fontSize: 30
      }))
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Button, {
    icon: /*#__PURE__*/React.createElement(_IconImage, null),
    onClick: () => setVisible(true),
    shape: "circle",
    type: "secondary"
  }), /*#__PURE__*/React.createElement(_Image.Preview, {
    src: src,
    visible: visible,
    onVisibleChange: setVisible
  }));
}